<template>
  <section class="space-y-4 mb-6">
    <slot />
  </section>
</template>
